import React, { useState, useEffect, useRef } from 'react'
import { SiderLayout } from 'modules/core/layouts'
import { tokenutils } from 'modules/login/actions'

export const FRONT_URL = process.env.REACT_APP_FRONT_URL || 'https://next.stg.getplika.com'

const CNRApprovalsHome = () => {
  const [loadingIframe, setLoadingIframe] = useState(false)
  const iframeRef = useRef(null)

  const params = new URLSearchParams(window.location.search)
  const id = params.get('id')

  useEffect(() => {
    // Listen for token requests from iframe
    const handleMessage = (event) => {
      if (event.data && event.data.type === 'token-request') {
        const token = tokenutils.getAccessToken()
        if (token) {
          // Send token to iframe
          const iframe = iframeRef.current
          if (iframe && iframe.contentWindow) {
            try {
              iframe.contentWindow.postMessage(
                {
                  type: 'token-response',
                  id: event.data.id,
                  token: token,
                },
                '*',
              )
              console.log('Token sent to iframe via postMessage')
            } catch (e) {
              console.error('Error sending token to iframe:', e)
            }
          }
        }
      }
    }

    window.addEventListener('message', handleMessage)
    return () => window.removeEventListener('message', handleMessage)
  }, [])

  useEffect(() => {
    const handler = (event) => {
      if (event.data?.type === 'FLOW_SELECTED') {
        const id = event.data.id

        const url = new URL(window.location.href)
        url.searchParams.set('id', id)

        window.history.replaceState({}, '', url.toString())
      }
    }

    window.addEventListener('message', handler)
    return () => window.removeEventListener('message', handler)
  }, [])

  const handleLoad = () => {
    console.log('Iframe loaded')
    setLoadingIframe(false)

    // Send token to iframe after it loads
    const token = tokenutils.getAccessToken()
    if (token && iframeRef.current?.contentWindow) {
      try {
        iframeRef.current.contentWindow.postMessage(
          {
            type: 'token-init',
            token: token,
          },
          '*',
        )
        console.log('Token sent to iframe on load')
      } catch (e) {
        console.error('Error sending token to iframe on load:', e)
      }
    }
  }

  return (
    <SiderLayout className={'dashboard-home-iframe'}>
      {loadingIframe && <div style={{ padding: 20, textAlign: 'center' }}>Cargando...</div>}
      <iframe
        ref={iframeRef}
        id="CNRApprovals"
        title="CNR Approvals"
        src={`${FRONT_URL}/iframe/cnr-approvals${id ? `?view=detail&id=${id}` : ''}`}
        width="100%"
        height="100%"
        style={{
          border: 'none',
          padding: '0 0',
          overflowX: 'hidden',
          overflowY: 'auto',
        }}
        onLoad={handleLoad}
      />
    </SiderLayout>
  )
}

export default CNRApprovalsHome
